import * as React from "react";
import { FormattedMessage, defineMessages } from "react-intl";
/* --- Miscellaneous Global Constants --- */
// must be less than state.auth.sessionLength, set by the API (currently 1800 seconds)
export const IDLE_SESSION_WARN_MODAL_DURATION = 60; // seconds
// config object for javascript key codes
export const KEY = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    TAB: 9,
    ESC: 27
};
const messages = defineMessages({
    Attorney: {
        id: "decedentRelationship.attorney",
        defaultMessage: "Attorney"
    },
    FamilyFriendOther: {
        id: "decedentRelationship.familyFriendOther",
        // zero width space to allow word wrap after slashes
        defaultMessage: "Family/{zeroWidthSpace}Friend/{zeroWidthSpace}Other"
    }
});
export const DECEDENT_RELATIONSHIPS_MESSAGES = {
    Attorney: messages.Attorney,
    FamilyFriendOther: {
        ...messages.FamilyFriendOther,
        values: {
            zeroWidthSpace: ""
        }
    }
};
export const DECEDENT_RELATIONSHIPS = {
    Attorney: (<FormattedMessage {...messages.Attorney}/>),
    FamilyFriendOther: (<FormattedMessage {...messages.FamilyFriendOther} values={{
        zeroWidthSpace: "\u200B"
    }}/>)
};
export const ASYNC_STATE = {
    NONE: "none",
    PENDING: "pending",
    RESOLVED: "resolved",
    REJECTED: "rejected"
};
export const PREFERRED_PHONE_TYPES = defineMessages({
    Home: {
        id: "preferredPhone.home",
        defaultMessage: "Home"
    },
    Cell: {
        id: "preferredPhone.cell",
        defaultMessage: "Cell"
    },
    Work: {
        id: "preferredPhone.work",
        defaultMessage: "Work"
    }
});
export const MAX_TIMEOUT = (2 ** 31) - 1;



// WEBPACK FOOTER //
// ./src/assets/scripts/constants/Constants.tsx